// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"31b89bfe","84":"31b89bfe","324":"31b89bfe","622":"31b89bfe","642":"31b89bfe"}[chunkId] + ".chunk.css";
};